import { from, Observable } from 'rxjs';
import { shareReplay, switchMap, tap } from 'rxjs/operators';
import { isArdoqError, type Result } from '@ardoq/common-helpers';
import type { InitiativeUpdateResponse } from '@ardoq/api-types';
import { api, transformationsApi } from '@ardoq/api';
import { action$, extractPayload, ofType } from '@ardoq/rxbeach';
import { trackEventV2 } from 'tracking/tracking';
import { updateInitiativeRequested } from './initiativePageForm$/actions';
import { dispatchDetectedSetupStatus } from '../setupStatusDetection';

export const updateInitiative$: Observable<Result<InitiativeUpdateResponse>> =
  action$.pipe(
    ofType(updateInitiativeRequested),
    extractPayload(),
    switchMap(payload =>
      from(transformationsApi.updateInitiative(payload)).pipe(
        tap(response => {
          if (!isArdoqError(response)) {
            trackEventV2({
              event: 'Initiatives0 Updated initiative',
              payload: { field: payload.field },
            });
          }
        })
      )
    ),
    tap(response => {
      dispatchDetectedSetupStatus(response);
      api.logErrorIfNeeded(response);
    }),
    shareReplay({ bufferSize: 1, refCount: true })
  );
